import { Modal } from '@studiometa/ui';

/**
 * @typedef {{}} ZoomedGalleryProps
 */

/**
 * ZoomedGallery ZoomedGallery.
 * @augments {Base<ZoomedGalleryProps>}
 */
export default class ZoomedGallery extends Modal {
  isOpen = false;

  imagesAreDisplayed = false;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'ZoomedGallery',
    refs: ['close', 'img[]'],
  };

  /**
   *
   */
  onClick() {
    this.closeGallery();
  }

  /**
   *
   */
  onCloseClick() {
    this.closeGallery();
  }

  /**
   *
   */
  openGallery() {
    this.isOpen = true;
    if (!this.imagesAreDisplayed) {
      this.showImages();
    }
    document.documentElement.classList.add('overflow-hidden');
    this.$el.classList.remove('opacity-0', 'pointer-events-none');
  }

  /**
   *
   */
  showImages() {
    this.$refs.img.forEach((element) => {
      element.style.display = 'block';
    });

    this.imagesAreDisplayed = true;
  }

  /**
   *
   */
  closeGallery() {
    this.isOpen = false;
    document.documentElement.classList.remove('overflow-hidden');
    this.$el.classList.add('opacity-0', 'pointer-events-none');
  }

  /**
   * Close panel when type on Escape key
   * @param {object} props Props
   * @param {object} props.ESC Escape key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeGallery();
    }
  }
}
